import React, { createContext } from 'react';

export const AnalyticsAppContext = createContext();

/* eslint-disable */
export function withAnalyticsAppContext(Component) {
    return (props) => (
        <AnalyticsAppContext.Consumer>
            {(context) => <Component {...props} appContext={context} />}
        </AnalyticsAppContext.Consumer>
    );
}
/* eslint-enable */
